import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { AnyPermissionString, Conditions } from '@nohara/oidc-core';

import { useCanAccess } from '../hooks';

export interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
  fallbackElement?: React.ReactNode;
  requireAll?: AnyPermissionString[];
  requireAny?: AnyPermissionString[];
  grantSelf?: AnyPermissionString[];
  context?: Conditions;
}

export const OidcProtectedComponent = ({
  children,
  redirectTo,
  fallbackElement = null,
  requireAll,
  requireAny,
  grantSelf,
  context,
}: ProtectedRouteProps) => {
  const navigate = useNavigate();

  const { canAccess, isLoading } = useCanAccess({
    requireAll,
    requireAny,
    grantSelf,
    context,
  });

  useEffect(() => {
    if (!canAccess && !isLoading && redirectTo) {
      if (redirectTo.startsWith('http')) {
        window.location.href = redirectTo;
      } else {
        navigate(redirectTo);
      }
    }
  }, [canAccess, isLoading, redirectTo, navigate]);

  if (!canAccess) {
    return fallbackElement;
  }

  return children;
};
